module.exports = __webpack_public_path__ + "static/img/4.abf322c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/User/4.png
// module id = R7SX
// module chunks = 0